var _defs, _g, _path, _path2, _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg01N(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 54.3,
    x2: 187.2,
    y1: 29,
    y2: 259.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#86c3db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#86c3db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5eafcf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 344.3,
    x2: 375.7,
    y1: 153.9,
    y2: 208.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcd966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fcd966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fccd34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "f",
    x1: 294,
    x2: 330,
    y1: 112.8,
    y2: 175.2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "g",
    x1: 356.3,
    x2: 387.7,
    y1: 194.8,
    y2: 249.2
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M512 27.5 240 189.1l16 48 40 32 216-96V27.5z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "h",
    viewBox: "0 0 270 270"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    stroke: "#72b9d5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M252.3 168.6A133.4 133.4 0 01118 36.2 130.5 130.5 0 01122.5 3 133 133 0 003 134.6C3 207.7 63 267 137.2 267c62.5 0 114.8-42.2 129.8-99.2a135.6 135.6 0 01-14.8.8Z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    additive: "sum",
    attributeName: "transform",
    dur: "6s",
    repeatCount: "indefinite",
    type: "rotate",
    values: "-15 135 135; 9 135 135; -15 135 135"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fcd34d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "m332 193.1-5.4 2.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fcd34d",
    strokeDasharray: "12.6 12.6",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M315.4 201.4 231 243.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fcd34d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "m225.4 246.4-5.4 2.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    stroke: "#fcd34d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m329.1 165.3 18 18.3a1.8 1.8 0 01.5 1.8l-6.5 24.9a1.8 1.8 0 003 1.7l18.4-18a1.8 1.8 0 011.7-.4l25 6.4a1.8 1.8 0 001.7-3l-18-18.4a1.8 1.8 0 01-.5-1.7l6.4-24.9a1.8 1.8 0 00-3-1.7l-18.3 18a1.8 1.8 0 01-1.7.4l-25-6.4a1.8 1.8 0 00-1.7 3Z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "d",
    additive: "sum",
    attributeName: "transform",
    begin: "0s; d.end+2s",
    dur: "1s",
    repeatCount: "indefinite",
    type: "translate",
    values: "-126 48; 42 -30"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "e",
    attributeName: "opacity",
    begin: "0s; e.end+2s",
    calcMode: "spline",
    dur: "1s",
    keySplines: ".42, 0, .58, 1; .42, 0, .58, 1; .42, 0, .58, 1",
    keyTimes: "0; .17; .67; 1",
    values: "0; 1; 1; 0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    stroke: "#fcd34d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m282.8 162.8 25-6.4a1.8 1.8 0 011.7.5l18.3 18a1.8 1.8 0 003-1.7l-6.4-25a1.8 1.8 0 01.5-1.7l18-18.4a1.8 1.8 0 00-1.8-3l-24.9 6.5a1.8 1.8 0 01-1.7-.5l-18.4-18a1.8 1.8 0 00-3 1.7l6.5 25a1.8 1.8 0 01-.5 1.7l-18 18.3a1.8 1.8 0 001.7 3Z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    additive: "sum",
    attributeName: "transform",
    calcMode: "spline",
    dur: "6s",
    keySplines: ".42, 0, .58, 1; .42, 0, .58, 1",
    repeatCount: "indefinite",
    type: "rotate",
    values: "-15 312 144; 15 312 144; -15 312 144"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    calcMode: "spline",
    dur: "6s",
    keySplines: ".42, 0, .58, 1; .42, 0, .58, 1; .42, 0, .58, 1; .42, 0, .58, 1; .42, 0, .58, 1; .42, 0, .58, 1",
    repeatCount: "indefinite",
    values: "1; .75; 1; .75; 1; .75; 1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    stroke: "#fcd34d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m337.3 223.7 24.8 7a1.8 1.8 0 011.3 1.2l6.9 24.8a1.8 1.8 0 003.4 0l7-24.8a1.8 1.8 0 011.2-1.3l24.8-6.9a1.8 1.8 0 000-3.4l-24.8-7a1.8 1.8 0 01-1.3-1.2l-6.9-24.8a1.8 1.8 0 00-3.4 0l-7 24.8a1.8 1.8 0 01-1.2 1.3l-24.8 6.9a1.8 1.8 0 000 3.4Z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    additive: "sum",
    attributeName: "transform",
    begin: "-.67s",
    calcMode: "spline",
    dur: "6s",
    keySplines: ".42, 0, .58, 1; .42, 0, .58, 1",
    repeatCount: "indefinite",
    type: "rotate",
    values: "-15 372 222; 15 372 222; -15 372 222"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-.67s",
    calcMode: "spline",
    dur: "6s",
    keySplines: ".42, 0, .58, 1; .42, 0, .58, 1; .42, 0, .58, 1; .42, 0, .58, 1; .42, 0, .58, 1; .42, 0, .58, 1",
    repeatCount: "indefinite",
    values: "1; .75; 1; .75; 1; .75; 1"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    width: 270,
    height: 270,
    transform: "translate(121 121)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg01N);
export default __webpack_public_path__ + "static/media/01n.26a9ccc189b04937002d1b0d10affe96.svg";
export { ForwardRef as ReactComponent };